import { Subaccount } from "@common/types/subaccount";

export class SubaccountDto {
    static deserialize(dto: SubaccountDto): Subaccount {
        return {
            ...dto,
        };
    }

    id: string;
    name: string;
    financialAccountId: number;
    sourceAccountId: string | null;
    accountNumber: string | null;

    constructor(subaccount: Subaccount) {
        this.id = subaccount.id;
        this.name = subaccount.name;
        this.financialAccountId = subaccount.financialAccountId;
        this.sourceAccountId = subaccount.sourceAccountId;
        this.accountNumber = subaccount.accountNumber;
    }
}
